import { render, staticRenderFns } from "./exitPermit.vue?vue&type=template&id=62dfff0e&scoped=true"
import script from "./exitPermit.vue?vue&type=script&lang=js"
export * from "./exitPermit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dfff0e",
  null
  
)

export default component.exports